import React from "react";
import { ShieldCheck, UserCheck, Lock, Headset, BadgeCheck } from "lucide-react";

const BADGES = [
  { id: "rta", icon: ShieldCheck, label: "RTA Compliant", note: "Roads & Transport Authority" },
  { id: "hosts", icon: UserCheck, label: "Verified Hosts", note: "ID + ownership checked" },
  { id: "payments", icon: Lock, label: "Secure Payments", note: "PCI-DSS · 3D Secure" },
  { id: "support", icon: Headset, label: "24/7 Support", note: "Dubai-based concierge" },
  { id: "license", icon: BadgeCheck, label: "UAE Licensed", note: "Operating in Dubai" },
];

export default function TrustBadges() {
  return (
    <section
      id="trust"
      data-testid="trust-section"
      className="relative py-24 sm:py-32 bg-white border-t border-carvny-border overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        {/* Editorial header */}
        <div className="grid grid-cols-12 gap-y-8 lg:gap-x-12 items-end">
          <div className="col-span-12 lg:col-span-4">
            <div className="text-[11px] font-bold uppercase tracking-[0.28em] text-carvny-red">
              §04 — Trust, in writing
            </div>
            <div className="rule mt-4" />
          </div>
          <div className="col-span-12 lg:col-span-8">
            <h2 className="font-display text-3xl sm:text-4xl lg:text-[52px] font-black tracking-tightest text-carvny-ink leading-[1.05]">
              Built for the way Dubai
              <span className="font-serif-italic font-normal text-carvny-ink/85"> actually </span>
              rents.
            </h2>
            <p className="mt-5 text-base text-carvny-muted leading-relaxed max-w-2xl">
              Every layer of CARVNY meets the bar set by UAE regulators and the
              people who depend on their cars every day.
            </p>
          </div>
        </div>

        {/* Badge grid */}
        <div className="mt-14 sm:mt-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-px bg-carvny-border border border-carvny-border rounded-[24px] overflow-hidden">
          {BADGES.map((b) => {
            const Icon = b.icon;
            return (
              <div
                key={b.id}
                data-testid={`trust-badge-${b.id}`}
                className="group bg-white p-6 sm:p-8 hover:bg-carvny-surface transition-colors"
              >
                <div className="w-10 h-10 rounded-xl bg-carvny-red-50 text-carvny-red flex items-center justify-center group-hover:bg-carvny-red group-hover:text-white transition-colors">
                  <Icon size={18} strokeWidth={2.2} />
                </div>
                <div className="mt-6 font-display text-base sm:text-lg font-bold text-carvny-ink leading-tight tracking-tight">
                  {b.label}
                </div>
                <div className="mt-1.5 text-[11px] font-semibold uppercase tracking-[0.16em] text-carvny-muted">
                  {b.note}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
